import * as React from "react";
export function SvgExpand(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width={12} height={12} {...props}>
      <path
        d="M11 4.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5V1.7L6.9 4.8c-.2.2-.5.2-.7 0-.1-.1-.2-.2-.2-.3s0-.3.1-.4L9.3 1H6.5C6.2 1 6 .8 6 .5s.2-.5.5-.5H11v4.5zM1 6.5v2.8l3.2-3.2c.1-.1.5-.1.7 0 .2.2.2.5 0 .7L1.7 10h2.8c.3 0 .5.2.5.5s-.2.5-.5.5H0V6.5c0-.3.2-.5.5-.5s.5.2.5.5z"
        fill="#666766"
      />
    </svg>
  );
}
